/**
 * 提供一个全局唯一的EventEmitter
 * emitter.on('someEvent', function(arg1, arg2) { })
 * emitter.emit('someEvent', 'arg1 参数', 'arg2 参数'); 
 */
const events = require('events');

export class EventBase {
    private static instance: EventBase;
    public emitter: any;
    private constructor() {
        this.emitter = new events.EventEmitter();
    }

    public static getInstance(): EventBase {
        if (!EventBase.instance) {
            EventBase.instance = new EventBase();
        }
        return EventBase.instance;
    }
}


